import React, { useMemo } from "react";
import { Field, FormSpy } from "react-final-form";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { atLeastOneFieldRequired, required } from "../../../../util/validators";
import { LoadingButton } from "../../../../components/LoadingButton";
import { Switch } from "../../../../components/inputs/final_form/Switch";
import { AdministrateSelectInput, AdminOptionableInput } from "../../../components/inputs/AdministrateSelectInput";
import { isBlank } from "../../../../util/helpers";
import { noop } from "lodash-es";
import { Card, CardBody, CardText } from "reactstrap";
import { Info } from "lucide-react";

const labToOption = (lab) => (lab ? [{ label: lab.labName, value: lab.id }] : []);

export const PreprocessingCategoryForm = ({ handleSubmit, submitting, initialValues, values }) => {
  const initialLabOptions = useMemo(() => labToOption(initialValues.lab), [initialValues]);
  const initialPayorOptions = useMemo(() => {
    return initialValues?.payors ? initialValues?.payors.map((payor) => ({ label: payor.name, value: payor.id })) : [];
  }, [initialValues?.payors]);
  const initialTestOptions = useMemo(() => {
    return initialValues?.tests ? initialValues?.tests.map((test) => ({ label: test.commercial_name, value: test.id })) : [];
  }, [initialValues?.tests]);

  return (
    <>
      {values && values.automated && (
        <Card color="info" className="bg-opacity-25 mb-3">
          <CardBody>
            <CardText>
              <Info size={24} className="me-2" />
              This is a System Automated Category.
            </CardText>
          </CardBody>
        </Card>
      )}
      <Field component={TextInput} label="Name" name="name" required validate={required} />

      <Field
        component={AdminOptionableInput}
        resource="labs"
        scope="with_servicing_provider"
        searchParam="lab_name"
        label="Lab"
        kept={true}
        name="labId"
        required={isBlank(values?.payorIds)}
        validate={values.automated ? noop : atLeastOneFieldRequired("payorIds")}
        initialOptions={initialLabOptions}
        initialValue={initialValues.lab?.id}
        disabled={values.automated}
      />

      <Field
        component={AdminOptionableInput}
        resource="payors"
        searchParam="name"
        label="Payors"
        kept={true}
        isMulti
        name="payorIds"
        validate={values.automated ? noop : atLeastOneFieldRequired("labId")}
        initialOptions={initialPayorOptions}
        required={isBlank(values?.labId)}
        disabled={values.automated}
      />

      <FormSpy subscription={{ values: true }}>
        {({ values }) => {
          return values.labId ? (
            <>
              <Field
                component={AdministrateSelectInput}
                resourceUrl={`/admin/tests.json?test[direction]=asc&test[order]=commercial_name&lab=${values.labId}&archived=false`}
                label="Tests"
                name="testIds"
                initialOptions={initialTestOptions}
                isMulti
              />
            </>
          ) : (
            <>
              <Field
                component={AdministrateSelectInput}
                resourceUrl={"/admin/tests.json?archived=false"}
                label="Tests"
                name="testIds"
                initialOptions={initialTestOptions}
                isDisabled={true}
                key="test-disabled"
                isMulti
              />
            </>
          );
        }}
      </FormSpy>

      <Field
        className="mb-3"
        component={Switch}
        type="checkbox"
        defaultValue={true}
        required
        validate={required}
        label="Active"
        name="active"
      />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
